<div class="descriptionText">
	{{ report.description }}
</div>
<div class="card m-2">
	<div class="d-flex">
		<div *ngFor="let option of reportOptions" class="mt-1 ms-0">
			<div *ngIf="option.type === 'dropdown'" class="mx-1">
				<span class="p-float-label">
					<p-dropdown
						#option{{option.ngModel}}
						[options]="option.options"
						optionLabel="option.optionLabel"
						optionValue="option.optionValue"
						name="option{{ option.ngModel }}"
						[(ngModel)]="option.ngModel"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(option.options)"
					></p-dropdown>
					<label for="option{{ option.ngModel }}">{{ option.label }}</label>
				</span>
			</div>
			<div *ngIf="option.type === 'multiSelect'" class="mx-1">
				<span class="p-float-label">
					<p-multiSelect
						#option{{option.ngModel}}
						[options]="option.options"
						optionLabel="option.optionLabel"
						optionValue="option.optionValue"
						name="option{{ option.ngModel }}"
						[(ngModel)]="option.ngModel"
						[style]="{ width: '100%' }"
						appendTo="body"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(option.options)"
					></p-multiSelect>
					<label for="option{{ option.ngModel }}">{{ option.label }}</label>
				</span>
			</div>
			<div *ngIf="option.type === 'calendar'" class="mx-1">
				<span class="p-float-label">
					<p-calendar
						#option{{option.ngModel}}
						(onSelect)="onCalendarSelect($event, option.ngModel)"
						(onInput)="onCalendarSelect($event, option.ngModel)"
					></p-calendar>
					<label for="option{{ option.ngModel }}">{{ option.label }}</label>
				</span>
			</div>
			<div *ngIf="option.type === 'time'" class="mx-1">
				<span class="p-float-label">
					<p-calendar #option{{ option.ngModel }} [(ngModel)]="option.ngModel" [timeOnly]="true" [hourFormat]="12" inputId="timeonly"></p-calendar>
					<label for="option{{ option.ngModel }}">{{ option.label }}</label>
				</span>
			</div>
		</div>

		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-success mt-1" (click)="reportRunChange.emit()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">Run Report</div>
				</ng-template>
			</p-button>
		</div>
	</div>
</div>
